"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shuffle = shuffle;
exports.pickRandom = pickRandom;
exports.randomIntBetween = randomIntBetween;
exports.uuid = uuid;
exports.hexid = hexid;
exports.htmlId = htmlId;
const ramda_1 = require("ramda");
const uuid_1 = require("uuid");
function shuffle(list) {
    const equalChance = 0.5;
    const randomComparator = () => equalChance - Math.random();
    return (0, ramda_1.sort)(randomComparator, list);
}
function pickRandom(array, count) {
    const shuffled = shuffle(array);
    return shuffled.slice(0, count);
}
/**
 *
 * @param min
 * @param max
 * @returns a random integer between min and max (inclusive)
 */
function randomIntBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
/**
 *
 * @returns a v4 uuid - random
 */
function uuid() {
    return (0, uuid_1.v4)();
}
/**
 * Hexadecimal ID generator
 * @param {number} size The size of the hexid (excluding the prefix)
 * @default 10
 * @param {string} prefix The prefix to add to the hexid
 * @optional
 * @returns {string} A hexid
 */
function hexid(size = 10, prefix = '') {
    const array = new Uint8Array(size);
    crypto.getRandomValues(array);
    const hexString = Array.from(array, byte => byte.toString(16).padStart(2, '0'))
        .join('')
        .slice(0, size);
    return prefix + hexString;
}
function htmlId(prefix = 'id') {
    return `${prefix}_${uuid()}`;
}
